import React, { useContext, useState } from "react";
import { CommandBarButton, CommandBarButtonMenuItem, useDisclosure } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../core/security/SprintAccessRight";
import { OnPremOrderStatus } from "../../../../common/types/OnPremOrderStatus";
import {
    allowedOnPremOrderStatuses,
    mapOnPremOrderStatusName
} from "../../../common/utils/getAvailableOnPremOrderStatuses";
import { OnPremOrderListingContext } from "../../context/OnPremOrderListingContext";
import { UpdateMultipleOnPremOrdersStatusDialog } from "./UpdateMultipleOnPremOrdersStatusDialog";

export const UpdateMultipleOnPremOrdersStatusButton: React.VFC = () => {
    const { selectedItems } = useContext(OnPremOrderListingContext);
    const [selectedStatus, setSelectedStatus] = useState<OnPremOrderStatus>();

    const { isOpen, onClose, onOpen } = useDisclosure();

    const statusOptions: CommandBarButtonMenuItem[] = allowedOnPremOrderStatuses.map((status) => ({
        key: String(status),
        text: mapOnPremOrderStatusName(status),
        onClick: () => {
            setSelectedStatus(Number(status));
            onOpen();
        }
    }));

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.OrdAdmin]}>
            <CommandBarButton
                text="Change status"
                icon="Edit"
                menuItems={statusOptions}
                disabled={selectedItems.length < 2}
            />
            {isOpen && (
                <UpdateMultipleOnPremOrdersStatusDialog
                    key={String(isOpen)}
                    onClose={onClose}
                    selectedStatus={selectedStatus}
                />
            )}
        </AuthorizationWrapper>
    );
};
